import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ShipnityCreatePage from "./pages/ShipnityCreatePage.vue";
import ShipnityUpdatePage from "./pages/ShipnityUpdatePage.vue";
import ShipnityViewPage from "./pages/ShipnityViewPage.vue";

export const ShipnityRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "shipnity"
) => [
  {
    name: "ShipnityViewPage",
    path: prefix,
    component: ShipnityViewPage,
    meta: { title: "Shipnity List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHIPNITY_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ShipnityCreatePage",
    path: `${prefix}/create`,
    component: ShipnityCreatePage,
    meta: { title: "Create New Shipnity" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHIPNITY_CREATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ShipnityUpdatePage",
    path: `${prefix}/edit/:id`,
    component: ShipnityUpdatePage,
    meta: { title: "Edit Shipnity" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHIPNITY_UPDATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
